var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20357_25083)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20357_25083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H17.0224V17.0017H1.5V1.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20357_25083)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73225 2.625C3.55425 2.625 2.625 3.732 2.625 6.32475V12.174C2.625 14.562 3.9435 15.8768 6.3375 15.8768H12.174C14.562 15.8768 15.8767 14.562 15.8767 12.174V12.1718L15.8977 8.448C15.8977 5.89875 15.0232 4.905 12.777 4.905H10.6545C9.94275 4.90425 9.26325 4.5645 8.83575 3.996L8.151 3.0855C7.93575 2.79675 7.5915 2.62575 7.2315 2.625H5.73225ZM12.174 17.0018H6.3375C3.354 17.0018 1.5 15.1515 1.5 12.174V6.32475C1.5 3.123 2.92425 1.5 5.73225 1.5H7.23225C7.9455 1.50075 8.625 1.84125 9.051 2.4105L9.73425 3.3195C9.951 3.6075 10.2952 3.77925 10.6552 3.78H12.777C15.6735 3.78 17.0227 5.26425 17.0227 8.451L17.0017 12.1762C17.001 15.1522 15.1515 17.0018 12.174 17.0018Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5366 11.7852H5.98535C5.67485 11.7852 5.42285 11.5332 5.42285 11.2227C5.42285 10.9122 5.67485 10.6602 5.98535 10.6602H12.5366C12.8471 10.6602 13.0991 10.9122 13.0991 11.2227C13.0991 11.5332 12.8471 11.7852 12.5366 11.7852Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20357_25083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBase);
export default __webpack_public_path__ + "static/media/icon-base.91ff1445b39275b7c3d5ea58568dd27b.svg";
export { ForwardRef as ReactComponent };